import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

import GlobalExplorerSearch from '../components/GlobalExplorerSearch';

const SearchCommandContext = createContext(null);

export function SearchCommandProvider({ children }) {
  const [open, setOpen] = useState(false);
  const returnFocusRef = useRef(null);
  const openSearch = useCallback((trigger = document.activeElement) => {
    returnFocusRef.current = trigger;
    setOpen(true);
  }, []);
  const closeSearch = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({
    searchOpen: open,
    openSearch,
    closeSearch,
  }), [closeSearch, open, openSearch]);

  return (
    <SearchCommandContext.Provider value={value}>
      {children}
      <GlobalExplorerSearch
        open={open}
        onClose={() => setOpen(false)}
        returnFocusRef={returnFocusRef}
      />
    </SearchCommandContext.Provider>
  );
}

export function useSearchCommand() {
  const context = useContext(SearchCommandContext);
  if (!context) throw new Error('useSearchCommand must be used inside SearchCommandProvider.');
  return context;
}
